import moment from 'moment'

// The dates picked in a screen, kept per tab so they survive a reload (switching branches, F5, a new version). Each
// screen has its own key. Only kept for the day they were picked on: a tab left open overnight starts on the default.
const prefix = 'storedDates.'

const isDate = (date) => typeof date === 'string' && moment(date, 'YYYY-MM-DD', true).isValid()

/**
 * @param {string} key the screen the dates belong to
 * @returns {{startDate: string, endDate: string} | null} the stored dates, null when there are none or they are no
 * longer valid
 */
export function getStoredDates(key) {
    try {
        const {startDate, endDate, day} = JSON.parse(sessionStorage.getItem(prefix + key))

        if (day !== moment().format('YYYY-MM-DD') || !isDate(startDate) || !isDate(endDate)) return null

        return {startDate, endDate}
    } catch {
        return null
    }
}

/**
 * @param {string} key the screen the dates belong to
 * @param {string} startDate YYYY-MM-DD
 * @param {string} endDate YYYY-MM-DD
 */
export function storeDates(key, startDate, endDate) {
    try {
        sessionStorage.setItem(prefix + key, JSON.stringify({startDate, endDate, day: moment().format('YYYY-MM-DD')}))
    } catch {
        // Storage blocked, the dates go back to the default on a reload
    }
}

// On logout, so logging in again starts every screen on its default
export function clearStoredDates() {
    try {
        const keys = []

        for (let i = 0; i < sessionStorage.length; i++) {
            const key = sessionStorage.key(i)

            if (key?.startsWith(prefix)) keys.push(key)
        }

        keys.forEach((key) => sessionStorage.removeItem(key))
    } catch {
        // Storage blocked, nothing stored
    }
}
